import ScalarColorModeToggle_default from "../ScalarColorModeToggle/ScalarColorModeToggle.vue.js";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, createElementVNode, createVNode, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref } from "vue";
//#region src/components/ScalarSidebar/ScalarSidebarFooter.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "flex items-center" };
var _hoisted_2 = { class: "flex-1 min-w-0 flex items-center text-sm text-sidebar-c-2" };
var ScalarSidebarFooter_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarSidebarFooter",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("flex flex-col gap-3 px-3 pb-3 border-sidebar-border"))), [renderSlot(_ctx.$slots, "default"), createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "description", {}, () => [_cache[0] || (_cache[0] = createElementVNode("a", {
				class: "no-underline hover:underline",
				href: "https://www.scalar.com",
				target: "_blank"
			}, " Powered by Scalar ", -1))])]), renderSlot(_ctx.$slots, "toggle", {}, () => [createVNode(unref(ScalarColorModeToggle_default))])])], 16);
		};
	}
});
//#endregion
export { ScalarSidebarFooter_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSidebarFooter.vue.script.js.map